import { useTranslation } from "react-i18next";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

const LANGUAGES = [
  { code: "en", label: "EN" },
  { code: "de-CH", label: "DE" },
  { code: "fr-CH", label: "FR" },
] as const;

export function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const handleChange = (value: string) => {
    i18n.changeLanguage(value);
    localStorage.setItem("language", value);
  };

  const currentLabel =
    LANGUAGES.find(l => l.code === i18n.language)?.label ?? "EN";

  return (
    <Select value={i18n.language} onValueChange={handleChange}>
      <SelectTrigger
        size="sm"
        className="w-[70px] border-[var(--border)] bg-[var(--background)] text-[var(--foreground)]"
        aria-label="Select language"
      >
        <SelectValue>{currentLabel}</SelectValue>
      </SelectTrigger>
      <SelectContent>
        {LANGUAGES.map(lang => (
          <SelectItem key={lang.code} value={lang.code}>
            {lang.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
